module.exports = __webpack_public_path__ + "static/media/Unit.96871cc6.svg";